// src/components/ui/filterFields.jsx
//
// The filter row's look, shared by "Storico Generazioni" (TenantRunListPage) and "Report Attività"
// (DashboardView) since v193 — lifted out of TenantRunListPage unchanged so the two pages cannot drift:
// the small upper-case label, the 46px field, and the date input with a calendar icon on the left that
// opens the native picker on click. Theme tokens only.
import React from 'react';
import { Calendar } from 'lucide-react';
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../../constants/theme.js';

export const FILTER_LABEL = {
  fontSize: '11px', fontWeight: 600, letterSpacing: '0.6px', textTransform: 'uppercase',
  color: COLORS.textTertiary, fontFamily: FONT_SANS, marginBottom: '8px',
};

export const FILTER_FIELD = {
  height: '46px', boxSizing: 'border-box',
  background: COLORS.surface, border: `1px solid ${COLORS.border}`,
  borderRadius: RADII.control, color: COLORS.ink,
  fontSize: '13px', fontFamily: FONT_SANS, outline: 'none',
};

/** A secondary button with the fields' height (e.g. "Reset filtri", "Ultimo mese"). */
export const FILTER_BUTTON = {
  ...FILTER_FIELD, padding: '0 20px', cursor: 'pointer',
  fontWeight: 600, border: `1px solid ${COLORS.borderStrong}`,
};

// Hide the native date-picker glyph — the design puts a calendar icon on the left.
const DATE_CSS = '.filter-date::-webkit-calendar-picker-indicator { opacity: 0; cursor: pointer; }';

export function FilterDateField({ value, onChange, invalid = false, ariaLabel }) {
  return (
    <div style={{ position: 'relative' }}>
      <style>{DATE_CSS}</style>
      <Calendar
        size={16} color={COLORS.textSecondary}
        style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}
      />
      <input
        type="date"
        className="filter-date"
        aria-label={ariaLabel}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        // Open the native calendar on click instead of typing by hand. Wrapped: showPicker() throws
        // if the transient user activation was already consumed (e.g. focus opened it first).
        onClick={(e) => { try { e.target.showPicker?.(); } catch { /* no user gesture */ } }}
        aria-invalid={invalid || undefined}
        style={{
          ...FILTER_FIELD, padding: '0 12px 0 40px', width: '160px', cursor: 'pointer',
          ...(invalid ? { borderColor: SEMANTIC.errore.fg } : null),
        }}
      />
    </div>
  );
}
